import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/partners/")({
  beforeLoad: () => {
    throw redirect({ to: "/partners/offers" });
  },
});
